import { absoluteDifference, fmtAns, squareKhit } from "./functions";

export const getVariant = (price, degrees, scale = 1) => {
  const originalPrice = price;
  price = price * scale;
  const [presult, nresult] = squareKhit(price, degrees);

  const firstDifference = absoluteDifference(price, presult);
  const secondDifference = absoluteDifference(price, nresult);

  return {
    originalPrice,
    price,
    degrees,
    presult,
    nresult,
    firstDifference,
    secondDifference,
  };
};

export const Results = ({
  colCss = "col-lg-2 col-md-6 mb-3",
  alertClass,
  first,
  second,
  firstDifference,
  secondDifference,
}) => {
  return (
    <div className={colCss}>
      <div className={`alert alert-${alertClass}`}>
        {/* <h6 className="text-center">Result</h6> */}
        <p className="text-center text-decoration-underline">{fmtAns(first)}</p>
        <p className="text-center text-decoration-underline">
          {fmtAns(second)}
        </p>
      </div>
      <div className={`alert alert-${alertClass}`}>
        <p className="text-center text-decoration-underline">
          {firstDifference ? fmtAns(firstDifference) : undefined}
        </p>
        <p className="text-center text-decoration-underline">
          {secondDifference ? fmtAns(secondDifference) : undefined}
        </p>
      </div>
    </div>
  );
};

export default function Variant({
  originalPrice,
  price,
  degrees,
  // result,
  presult,
  nresult,
  presultAvg,
  nresultAvg,
  priceLabel,
  firstDifference,
  secondDifference,
  alertClass = "secondary",
  colClass = "col-lg-2 col-md-6 mb-3",
}) {
  // const [presult, nresult] = result;
  const range = presult - nresult;
  return (
    <div className={colClass}>
      <div className="mb-5">
        <div className="form-group mb-4">
          <label>Price (I5) {priceLabel}</label>
          <input
            type="number"
            className="form-control"
            step="0.01"
            value={price}
            disabled
          />
        </div>
        <div className="form-group mb-4">
          <label>{/**Degrees */}Time (K5)</label>
          <input
            type="number"
            className="form-control"
            step="0.0000001"
            value={degrees}
            max="900"
            min="-900"
            disabled
          />
        </div>
      </div>
      {/* {priceLabel === "* 10" && <h6>ODM</h6>} */}
      <div
        className={`row  ${priceLabel.startsWith("*") ? "flex-row-reverse" : ""}`}
      >
        <Results
          alertClass={alertClass}
          colCss="col-6"
          first={presult}
          second={nresult}
          firstDifference={firstDifference}
          secondDifference={secondDifference}
        />
        <Results
          alertClass={"secondary"}
          colCss="col-6"
          first={presultAvg}
          second={nresultAvg}
          firstDifference={absoluteDifference(originalPrice, presultAvg)}
          secondDifference={absoluteDifference(originalPrice, nresultAvg)}
        />
      </div>
      {priceLabel === "* 10" ? (
        <div className="mb-5">
          <h6>ODM</h6>
          <div className="form-group mb-1">
            <label>Range</label>
            <input
              type="number"
              className="form-control"
              step="0.01"
              value={range.toFixed(2)}
              disabled
            />
          </div>
          <div className="form-group mb-1">
            <label>A/10 - Res</label>
            <input
              type="number"
              className="form-control"
              step="0.0000001"
              value={(presult / 10 - range).toFixed(2)}
              disabled
            />
          </div>
          <div className="form-group mb-1">
            <label>B/10 + Res</label>
            <input
              type="number"
              className="form-control"
              step="0.0000001"
              value={(nresult / 10 + range).toFixed(2)}
              disabled
            />
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
